// import '@/assets/css/index.css';
import 'whatwg-fetch';
import Vue from 'vue';
import cookie from 'js-cookie';
import App from './App.vue';
import { wxOauth, login } from './libs/api';
import { getRoute, getQueryString } from './libs/utils';
import router from './router';
async function init() {
  const params = new URLSearchParams(window.location.search.slice(1));
  const code = params.get('code');
  const state = params.get('state');
  const marsUuid = cookie.get('mars_uuid') || '';
  const openId = cookie.get('open_id');
  const marsAccessToken = cookie.get('mars_access_token');

  if (
    // 不在微信内
    !/MicroMessenger/.test(navigator.userAgent) ||
    // 没有提供 code，且没有 openId/marsAccessToken (票据异常)
    (!code && (!openId || !marsAccessToken)) ||
    // 提供了 code，但是 state 不对
    (code && state !== marsUuid.replace(/-/g, ''))
  ) {
    wxOauth();
    return;
  }
  const originUrl = signatureUrl();
  const fullUrl = `${location.protocol}//${location.host}${location.pathname}`;
  const queryType = getQueryString('type');
  const queryUrl = queryType ? `${fullUrl}?type=${queryType}` : fullUrl;
  const routeName = getRoute();
  const url = routeName ? `${queryUrl}${routeName}` : queryUrl;
  window.history.replaceState({}, document.title, url);
  if (typeof window.setShareInfo === 'function') {
    window.setShareInfo({
      title: '腾讯引进Nintendo Switch一岁啦！',
      summary: 'e商店游戏史低折扣促销火热进行中！',
      url: `${fullUrl}#/home`, // 分享的url固定是活动首页
      signatureUrl: originUrl, // 原始进入页面
      pic: 'https://switch-cn.gtgres.com/anniversary-activity/share.jpg'
    });
  }
  if (code) {
    await login({ uuid: marsUuid, code });
  }
  new Vue({
    router,
    render: (h) => h(App)
  }).$mount('#app');
}

function signatureUrl() {
  const currentUrl = location.href;
  const index = location.href.indexOf('#');
  if (index !== -1) {
    return currentUrl.substr(0, index);
  }
  return currentUrl;
}

init();
